import React, { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Link } from 'react-router-dom';
import PSignupModal from '../PSignupModal';
import FollowingGlobal from '../following-global.js';
import TickSmall from '../../images/tick_small_edit.png';
import Avatar from '../Avatar';
import { useEffect } from 'react';
import { ROLES, s3Link, VERIFIED_STATUS } from '../../utils/constants';
import { useMediaQuery } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2.js';
import DefaultPUWidget from '../../Widgets/PU/Default/index.js';
import DefaultWidget from '../../Widgets/SU/Default/index.js';
import { connect } from 'react-redux';
import CoverPic from '../CoverPic/index.js';
import { Tooltip, OverlayTrigger } from "react-bootstrap";

const SUPageContent = ({ user, getUserInformation, userInformation }) => {
    const isMobile = useMediaQuery('(max-width: 899px)');
    const isLoggedIn = localStorage.getItem('loggedin_user');

    const [show, setShow] = useState(false);

    return (
        <div className="su-profile-page-content">
            <Grid2
                container
                spacing={isMobile ? 0 : 2}
            >
                <Grid2 md={8}>
                    <PSignupModal showModal={show} setShowModal={setShow} user={user} />
                    <div className="profile-container su-profile">
                        <div className={`profile-banner`}>
                            <CoverPic user={user} />
                        </div>
                        <div className="profile-banner-details">
                            <div className="container">
                                <div className="profile-user-info-container">
                                    <div className="profile-user-avatar-wrapper">
                                        <div className="profile-user-avatar">
                                            <Avatar pu={user} story={false} size="150" />
                                        </div>
                                    </div>
                                    <div className="profile-user-info-top">
                                        <div className="profile-user-name">
                                            <h4>
                                                <b>{user.firstname || ''}</b>
                                                {' '}
                                                <span><LazyLoadImage src={TickSmall} /></span>
                                            </h4>
                                            <p>@
                                                {user.login || ''}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="profile-user-info-bottom">
                                        <div className="profile-user-bottom-list su-view">
                                            {(() => {
                                                if (isLoggedIn) {
                                                    return (
                                                        <div className="profile-user-btns-container su">
                                                            <OverlayTrigger defaultOverlayShown={true} delayHide={10000} overlay={<Tooltip placement="top" className="in" id="tooltip-top">Edit Profile</Tooltip>}>
                                                                <a href="/edit-profile" className="edit-profile-btn">
                                                                    <span>
                                                                        <i className="fa-regular fa-gear"></i>
                                                                    </span>
                                                                </a>
                                                            </OverlayTrigger>
                                                        </div>
                                                    );
                                                }
                                                return (
                                                    <div className="profile-user-btns-container">
                                                        {/* <a onClick={handleClick} className="btn theme-btn theme-btn-bordered text-uppercase">Follow $9.02</a> */}
                                                    </div>
                                                );
                                            })()}
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container following-content"><FollowingGlobal /></div>
                </Grid2>

                <Grid2 className='su-homepage__right' md={4}>
                    {
                        userInformation.role == ROLES.PU ? <DefaultPUWidget /> : null
                    }
                    {
                        userInformation.role == ROLES.SU ? <DefaultWidget /> : null
                    }
                </Grid2>
            </Grid2>
        </div>
    );
};

const mapStateToProps = (state) => ({
    userInformation: state.user.user
});

export default connect(mapStateToProps)(SUPageContent);
